module.exports = __webpack_public_path__ + "eaa103bdcae269fcaa6b41525ddd86f4.svg";